import { render } from "./DraggableList.vue?vue&type=template&id=51a49f28&scoped=true"
import script from "./DraggableList.vue?vue&type=script&lang=js"
export * from "./DraggableList.vue?vue&type=script&lang=js"

import "./DraggableList.vue?vue&type=style&index=0&id=51a49f28&scoped=true&lang=css"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a49f28"]])

export default __exports__